package com.vizio.redwolf.utils.clientprovider

enum class WebApiUseCase {
    COOKIE_SDK_HEADERS,
    SDK_HEADERS,
    BASIC
}